import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
import "./PeerConsultation.css";
import firepadRef from "../../config/firebase"; // Import the Firebase reference
import Draggable from "react-draggable";

import MainScreen from "../MainScreen/MainScreen";
import DicomViewer from "../Draw/DicomViewer";
import DwvComponent from "../../DwvComponent";
import axios from "axios";

const recommendationsList = [
  { id: "recBmpCmp", label: "BMP / CMP" },
  { id: "recA1c", label: "Hemoglobin A1c" },
  { id: "recLipid", label: "Lipid Profile" },
  { id: "recEcho", label: "Echocardiogram" },
  { id: "recCxr", label: "Chest X-Ray" },
  { id: "recCardiology", label: "Refer to Cardiology" },
  { id: "recEndocrinology", label: "Refer to Endocrinology" },
  { id: "recNephrology", label: "Refer to Nephrology" },
  { id: "recNutritionist", label: "Nutritionist Referral" },
  { id: "recSmokingCessation", label: "Smoking Cessation Counseling" },
  { id: "rec2wkFollowUp", label: "Schedule 2-Week Follow-Up" },
  { id: "recHomeBP", label: "Home BP Monitoring" },
];

const PeerConsultation = () => {
  const [checkedItems, setCheckedItems] = useState([]);

  const [error, setError] = useState(null);
  const urlparams = new URLSearchParams(window.location.search);
  const meetingId = urlparams.get("id"); // Get the meeting ID from the URL // Get the user ID from the URL
  const providerId = urlparams.get("providerId"); // Get the user ID from the URL

  // const location = useLocation();
  const [consultation, setConsultation] = useState(null);
  const [presentation, setPresentation] = useState(false);
  const [patientInfo, setPatientInfo] = useState({
    name: "Loading...",
    dob: "Loading...",
    gender: "Loading...",
    address: "Loading...",
  });

  const [newNote, setNewNote] = useState("");
  const [meetingNotes, setMeetingNotes] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [seconds, setSeconds] = useState(0);
  const [isPip, setIsPip] = useState(false);
  const [drawMode, setDrawMode] = useState(false);
  const [imageUrl, setImageUrl] = useState(
    "https://images.pexels.com/photos/5723875/pexels-photo-5723875.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
  );

  const videoCardRef = useRef(null);
  const canvasRef = useRef(null);
  const timerRef = useRef(null);
  const isDrawingRef = useRef(false);
  const penColorRef = useRef(
    "#" + Math.floor(Math.random() * 16777215).toString(16)
  );
  const [accessToken, setAccessToken] = useState(null);

  const formatAddress = (address) => {
    const { street, city, town } = address;
    return `${street}, ${city}, ${town?.name}`;
  };

  const isChecked = (id) => {
    return checkedItems.some((item) => item.id === id);
  };
  const handleChange = (item) => {
    setCheckedItems((prev) => {
      if (isChecked(item.id)) {
        // Remove if already checked
        return prev.filter((i) => i.id !== item.id);
      } else {
        // Add if not checked
        return [...prev, item];
      }
    });
  };

  const saveMeetingData = () => {
    if (checkedItems.length === 0 || meetingNotes.length === 0) {
      return;
    }

    console.log("aslfjalskjfalksj", checkedItems);

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://impilo-engageapi.mohcc.gov.zw/patient-data/api/appointments/update-meeting-data",
      headers: {
        "Content-Type": "application/json",

        Authorization: `Bearer ${accessToken}`,
      },
      data: {
        meetingUserNotes: JSON.stringify(meetingNotes),
        meetingRecommendations: JSON.stringify(checkedItems),
        meetingId: meetingId,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!accessToken) return;

    // Interval every 30 seconds
    const intervalId = setInterval(() => {
      saveMeetingData();
    }, 60000); // 30000ms = 30s

    // Cleanup on unmount
    return () => clearInterval(intervalId);
  }, [meetingNotes, checkedItems, accessToken]); // Re-run if data or token changes

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, []);

  useEffect(() => {
    const fetchConsultations = async () => {
      try {
        // Step 1: Get the access token
        const tokenResponse = await axios.post(
          "https://impilo-engageapi.mohcc.gov.zw/oauth/token",
          new URLSearchParams({
            grant_type: "password",
            username: "id_m",
            password: "1122",
            loginType: "PIN",
            client_id: "y785gg09org",
            client_secret: "1op9tfxy7",
            userRole: "PROVIDER",
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        const accessToken = tokenResponse.data.access_token;

        setAccessToken(accessToken);
        // Step 2: Get consultation details using token
        const response = await axios.get(
          `https://impilo-engageapi.mohcc.gov.zw/patient-data/api/appointments/patient/${meetingId}/detail`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        const consultationData = response.data.result;

        setConsultation(consultationData);
        setParticipants(consultationData.providerFacilities || []);

        setPatientInfo({
          name: consultationData?.person
            ? `${consultationData?.person?.firstname} ${consultationData?.person?.lastname}`
            : "Unknown",
          dob: consultationData?.person
            ? consultationData?.person.birthdate
            : "Unknown",
          gender: consultationData?.person
            ? consultationData?.person.sex
            : "Unknown",
          address:
            consultationData?.person && consultationData?.person?.address
              ? `${consultationData.person.address.street}, ${consultationData.person.address.city}, ${consultationData.person.address.town?.name}`
              : "Unknown",
        });
      } catch (err) {
        console.error("Error fetching consultations:", err);
        setError(err.message || "Something went wrong");
      }
    };

    fetchConsultations();
  }, []);

  const handleAddNote = () => {
    if (!newNote.trim()) return;
    const timestamp = new Date().toLocaleString();

    const newMessage = {
      id: Date.now(),
      userId: providerId,
      content: newNote.trim(),

      time: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };

    // Push the new message to Firebase
    const messagesRef = firepadRef.child("meeting-notes").child(meetingId);
    messagesRef.push(newMessage);

    setMeetingNotes([newMessage, ...meetingNotes]);
    setNewNote("");
  };

  // PIP functionality
  useEffect(() => {
    const handleScroll = () => {
      if (!videoCardRef.current) return;

      const rect = videoCardRef.current.getBoundingClientRect();

      console.log(rect.top, "Tesetingngsngn");
      if (rect.top < 0 && !isPip) {
        setIsPip(true);
      } else if (rect.top >= 0) {
        setIsPip(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [isPip]);

  // Canvas setup
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const viewer = document.getElementById("dicomViewer");

    const resizeCanvas = () => {
      if (!viewer) return;
      canvas.width = viewer.clientWidth;
      canvas.height = viewer.clientHeight;
    };

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    return () => window.removeEventListener("resize", resizeCanvas);
  }, []);

  // Drawing functionality
  const setupDrawing = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    const startDrawing = (e) => {
      isDrawingRef.current = true;
      ctx.beginPath();
      const rect = canvas.getBoundingClientRect();
      ctx.moveTo(e.clientX - rect.left, e.clientY - rect.top);
    };

    const draw = (e) => {
      if (!isDrawingRef.current) return;

      const x = e.nativeEvent.offsetX;
      const y = e.nativeEvent.offsetY;
      const rect = canvas.getBoundingClientRect();
      ctx.lineTo(e.clientX - rect.left, e.clientY - rect.top);
      ctx.strokeStyle = penColorRef.current;
      ctx.lineWidth = 2;
      ctx.stroke();

      // Save to Firebase Realtime DB
      const point = {
        x,
        y,
        providerId,
        timestamp: Date.now(),
      };

      const pointsRef = firepadRef.child("drawings").child(meetingId);
      pointsRef.push(point); // this is like adding a message
    };

    const stopDrawing = () => {
      if (isDrawingRef.current) ctx.closePath();
      isDrawingRef.current = false;
    };

    canvas.addEventListener("mousedown", startDrawing);
    canvas.addEventListener("mousemove", draw);
    window.addEventListener("mouseup", stopDrawing);

    return () => {
      canvas.removeEventListener("mousedown", startDrawing);
      canvas.removeEventListener("mousemove", draw);
      window.removeEventListener("mouseup", stopDrawing);
    };
  };

  useEffect(() => {
    if (!drawMode) return;
    return setupDrawing();
  }, [drawMode]);

  // Helper functions
  const formatTime = () => {
    const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${mins}:${secs}`;
  };

  const isOrganizer = consultation?.participants?.some(
    (p) => p.participantId === providerId && p.role === "Organizer"
  );

  return (
    // <MainScreen />
    <div className="container">
      <div className="row g-3 align-items-stretch">
        <div
          className="col-lg-4 col-md-12 d-flex flex-column"
          style={{ height: "100%" }}
        >
          {isOrganizer && (
            <div className="card mb-4 shadow-sm">
              <div className="card-header bg-success text-white d-flex align-items-center">
                <span className="me-2">👤</span>
                <h5 className="mb-0">Patient Information</h5>
              </div>
              <div className="card-body">
                <div className="row mb-3 align-items-center">
                  <div className="col-sm-4 text-muted small">Name</div>
                  <div className="col-sm-8 fw-semibold" id="patientName">
                    {patientInfo?.name}
                  </div>
                </div>
                <hr className="my-1" />
                <div className="row mb-3 align-items-center">
                  <div className="col-sm-4 text-muted small">Date of Birth</div>
                  <div className="col-sm-8 fw-semibold" id="patientDob">
                    {patientInfo?.dob}
                  </div>
                </div>
                <hr className="my-1" />
                <div className="row mb-3 align-items-center">
                  <div className="col-sm-4 text-muted small">Gender</div>
                  <div className="col-sm-8 fw-semibold" id="patientGender">
                    {patientInfo?.gender}
                  </div>
                </div>
                <hr className="my-1" />
                <div className="row mb-0 align-items-center">
                  <div className="col-sm-4 text-muted small">Address</div>
                  <div className="col-sm-8 fw-semibold" id="patientAddress">
                    {patientInfo?.address}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="card mb-4 shadow-sm">
            <div className="card-header text-black d-flex align-items-center">
              <span className="me-2">📝</span>
              <h5 className="mb-0">Shared Notes</h5>
            </div>
            <div className="card-body">
              {/* Text Input for New Note */}
              <div className="mb-3">
                <label
                  htmlFor="sharedNotesTextarea"
                  className="form-label small text-muted"
                >
                  Notes
                </label>
                <textarea
                  id="sharedNotesTextarea"
                  className="form-control"
                  rows="3"
                  placeholder="Enter your notes here..."
                  value={newNote}
                  onChange={(e) => setNewNote(e.target.value)}
                ></textarea>
                <button
                  className="btn btn-primary mt-2"
                  onClick={handleAddNote}
                >
                  Add Note
                </button>
              </div>

              {/* Scrollable Notes List */}
              <div
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  borderTop: "1px solid #dee2e6",
                  paddingTop: "1rem",
                }}
              >
                {meetingNotes.length === 0 ? (
                  <p className="text-muted">No notes yet.</p>
                ) : (
                  meetingNotes?.map((note, index) => (
                    <div key={index} className="mb-2">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <strong>{note.userId}</strong>

                        <div className="fw-bold">
                          <small className="text-muted">{note.time}</small>
                        </div>
                      </div>
                      <div>{note.content}</div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

          <div className="card p-4 shadow-sm">
            <h5 className="card-title">Participants</h5>
            <div
              id="participantsList"
              className="mt-3"
              style={{ maxHeight: "300px", overflowY: "auto" }} // Add scrolling here
            >
              {participants?.map((part) => {
                const firstName = part.pfirstName || "";
                const lastName = part.plastName || "";
                const fullName = `${firstName} ${lastName}`.trim() || "—";

                const rawQual =
                  part.practitionerQualifications || "No qualifications";
                const qual = rawQual
                  .toLowerCase()
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ");

                const facName = part.facilityName || "Unknown Facility";

                let initials = "—";
                if (firstName || lastName) {
                  const f = firstName.charAt(0) || "";
                  const l = lastName.charAt(0) || "";
                  initials = (f + l).toUpperCase();
                }

                return (
                  <div
                    className="mt-3"
                    style={{ display: "flex" }}
                    key={part.id || fullName}
                  >
                    <div className="participant-avatar">{initials}</div>
                    <div className="flex-grow-1">
                      <div className="participant-name">{fullName}</div>
                      <div className="participant-qual">{qual}</div>
                      <div className="participant-fac">{facName}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="col-lg-8 col-md-12">
          {isPip && (
            <div className="card22 card mb-3" id="videoCard" ref={videoCardRef}>
              <Draggable>
                <div
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    width: "320px",
                    // height: "500px",
                    background: "transparent",
                    // boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                    zIndex: 1000,
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="d-flex justify-content-between align-items-center p-2 bg-success text-white"
                    style={{ cursor: "move" }}
                  >
                    <strong>Peer Consultation</strong>
                    <button
                      className="btn btn-sm btn-light"
                      onClick={() => {
                        setIsPip(false);

                        window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top
                      }}
                    >
                      ❌
                    </button>
                  </div>

                  <MainScreen isPip={isPip} />
                </div>
              </Draggable>
            </div>
          )}
          {!isPip && (
            <div className="card22 card mb-3" id="videoCard" ref={videoCardRef}>
              <div className="card-header bg-success text-white d-flex align-items-center">
                <span className="me-2">🎥</span>
                <h5 className="mb-0">Peer Consultation</h5>
                <div className="ms-auto small">
                  Timer: <span id="timerDisplay">{formatTime(seconds)}</span>
                </div>
              </div>

              <MainScreen />
            </div>
          )}

          <div className="card p-4" style={{ marginTop: 0 }}>
            <h5 className="card-title">Patient Notes</h5>
            <div className="mb-3" id="meetingNotesContainer">
              <p className="text-muted" id="meetingNotesText">
                {consultation?.notes}
              </p>
            </div>

            <button className="btn btn-dark w-100 mb-3"></button>

            <div className="card p-2 mb-3 auto-expand-card">
              <h6 className="card-title">Follow-Up Recommendations</h6>
              <ul className="list-unstyled row">
                {recommendationsList.map((item) => (
                  <li className="col-3" key={item.id}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={item.id}
                        checked={isChecked(item.id)}
                        onChange={() => handleChange(item)}
                      />
                      <label className="form-check-label" htmlFor={item.id}>
                        {item.label}
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <hr />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <h5>DICOM Image Viewer & Annotation</h5>
        </div>
      </div>
      <div className="row g-3">
        <div className="col-lg-9 col-md-12">
          <DwvComponent
            presentation={presentation}
            setPresentation={() => {
              setPresentation(!presentation);
            }}
            meetingId={meetingId}
            userId={providerId}
            imageUrl={imageUrl}
          />
        </div>

        <div className="col-lg-3 col-md-12">
          <div className="card p-4">
            <h5 className="card-title">Documents</h5>
            <div className="list-group doc-list">
              <a
                className="list-group-item list-group-item-action"
                onClick={() => {
                  setImageUrl(
                    "https://images.pexels.com/photos/5723875/pexels-photo-5723875.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                  );
                }}
              >
                DICOM Image 1
              </a>
              <a
                className="list-group-item list-group-item-action"
                onClick={() =>
                  setImageUrl(
                    "https://images.pexels.com/photos/5723877/pexels-photo-5723877.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                  )
                }
              >
                DICOM Image 2
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeerConsultation;
